<template>
    <div class="welcome-patient-page">
        <h1>{{message}}</h1>
    </div>
</template>
<script>
    export default
    {
        name:   'WelcomePatient',
        data ()
        {
            return {
                message: "Welcome Patient " + this.$store.state.user.username 
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/patient/patient-welcome.vue